import React, { Component, ErrorInfo, ReactNode } from 'react';

import AppErrorPage from '../AppError/AppErrorPage';
import { resolveSupportCode } from '../../../utils/supportCode';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary capturou um erro:', error, errorInfo);

    this.setState({
      error,
      errorInfo,
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined, errorInfo: undefined });
  };

  render() {
    if (this.state.hasError) {
      return (
        <AppErrorPage
          variant="unexpected"
          layout="fullPage"
          onRetry={this.handleRetry}
          supportCode={resolveSupportCode(this.state.error)}
          devError={this.state.error}
          devErrorInfo={this.state.errorInfo}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
